import appConfig from '~/config/app'

export function isDevelopmentEnvironment(): boolean {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === 'local'
}

export function isCheatFunctionalityEnabled(): boolean {
  return !appConfig.isProdEnvironment
}
